import { isNumber } from '@/src/helpers';
import { Path } from 'react-hook-form';
import z from 'zod';

const fromSchema = z.object({
  token: z.string(),
  amount: z
    .string()
    .min(0, 'Amount is required')
    .refine(
      (val) => (isNumber(parseFloat(val)) && parseFloat(val) >= 0) || val === '',
      'Amount must be a positive number'
    ),
});

const toSchema = z.object({
  token: z.string(),
  amount: z.string().min(-1, 'Amount is required'),
});

export const tokenSelectorsFormSchema = z.object({
  from: fromSchema,
  to: toSchema,
  pathIndex: z.string(),
});

export type TokenSelectorsFormValues = z.infer<typeof tokenSelectorsFormSchema>;

export type TokenSelectorsFieldPath = Path<TokenSelectorsFormValues>;
